import * as React from "react";
const SvgIcKeyboardShift = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.5 16.833v-6.666H16l-6-6.309-6 6.309h2.5v6.666h7ZM10 1.5l9.333 10.333h-4.166V18.5H4.833v-6.667H.667L10 1.5Z" /></svg>;
export default SvgIcKeyboardShift;